import * as UserState from 'components/desktop/User/User/State';
import { Handlers } from 'components/desktop/User/User/useState';
import ListItem from 'components/desktop/_general/ListItem/ListItem';

interface IProps {
	state: UserState.Type;
	handlers: Handlers;
}

const ApiKeyList = ({ state, handlers }: IProps) => {
	return (
		<div>
			{state.apiKeys.map((apiKey, index) => (
				<ListItem
					key={index}
					text={apiKey.displayName}
					title={apiKey.expirationTime?.toDateString()}
					handleDelete={() => {
						handlers.removeApiKey(apiKey.id);
					}}
					handleEdit={() => {
						handlers.setCurrentApiKeyId(apiKey.id);
					}}
					backgroundColor="#EFEFEF"
				/>
			))}
		</div>
	);
};

export default ApiKeyList;
